module.exports = __webpack_public_path__ + "static/sound-illustration-44b72fa590fa35e5dea90c4d2f7ea6fe.webm";